import React from 'react';
import {Link} from "react-router-dom";

const PressRelease = ({
    title,
    date,
    image,
    url
}) => {
    return (
        <Link className='single-release flex col' to={url} target={url ? '_blank' : ''}>
            <img src={'/images/media' + image} alt=''/>
            <h3>{title}</h3>
            <span>{date}</span>
        </Link>
    );
};

export default PressRelease;